import { ArrowRightCircleIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";

const Form = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState(null);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    return isValidEmail;
  };

  const handleBlur = (e) => {
    const nameInput = e.target.name;
    delete errors[nameInput];
    const newErrors = { ...errors };
    if (nameInput === "email") {
      if (!validateEmail(form.email))
        newErrors.email = "Please enter a valid email address";
      if (!form.email) newErrors.email = "Email is required";
    }
    if (nameInput === "name" && !form.name) newErrors.name = "Name is required";
    if (nameInput === "subject" && !form.subject)
      newErrors.subject = "Subject is required";
    if (nameInput === "message" && !form.message)
      newErrors.message = "Message is required";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
  };

  useEffect(() => {
    if (status === "success" || status === "error") {
      const timer = setTimeout(() => setStatus(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    const newErrors = {};
    if (!form.name) newErrors.name = "Name is required";
    if (form.email && !validateEmail(form.email))
      newErrors.email = "Please enter a valid email address";
    if (!form.email) newErrors.email = "Email is required";
    if (!form.subject) newErrors.subject = "Subject is required";
    if (!form.message) newErrors.message = "Message is required";
    if (Object.keys(newErrors).length > 0) {
      setStatus("error");
      setErrors(newErrors);
      return;
    }
    try {
      const res = await fetch("/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email,
          name: form.name,
          subject: form.subject,
          message: form.message,
        }),
      });
      if (res.ok) {
        setStatus("success");
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="bg-white py-3 md:p-5 w-full flex justify-center">
      <form
        className=" bg-gray-200 shadow-lg p-5 w-full md:w-3/4"
        onSubmit={handleSubmit}
      >
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="relative">
            <input
              type="text"
              id="name"
              name="name"
              value={form.name}
              onChange={handleChange}
              onBlur={handleBlur}
              className="peer w-full border-b-2 border-gray-300 focus:outline-none
              focus:bg-gray-200 focus:border-midnight transition-all duration-300 pt-5 pb-2 px-3 rounded-t-sm text-sm"
              placeholder=""
            />
            <label
              htmlFor="name"
              className="absolute left-2 top-1 text-xs
              text-midnight transition-all duration-300 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base
               peer-placeholder-shown:text-gray-600 peer-focus:top-1 peer-focus:text-xs peer-focus:text-midnight"
            >
              Name
            </label>
            {errors.name && <p className="text-red-400 py-2">{errors.name}</p>}
          </div>
          <div className="relative">
            <input
              type="text"
              id="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className="peer w-full border-b-2 border-gray-300 focus:outline-none
              focus:bg-gray-200 focus:border-midnight transition-all duration-300 pt-5 pb-2 px-3 rounded-t-sm text-sm"
              placeholder=" "
            />
            <label
              htmlFor="email"
              className="absolute left-2 top-1 text-xs
              text-midnight transition-all duration-300 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base
               peer-placeholder-shown:text-gray-600 peer-focus:top-1 peer-focus:text-xs peer-focus:text-midnight"
            >
              Email
            </label>
            {errors && errors.email && (
              <p className="text-red-400 py-2">{errors.email}</p>
            )}
          </div>
        </div>
        <div className="relative">
          <input
            type="text"
            id="subject"
            name="subject"
            value={form.subject}
            onBlur={handleBlur}
            onChange={handleChange}
            className="peer w-full border-b-2 border-gray-300 focus:outline-none
              focus:bg-gray-200 focus:border-midnight transition-all duration-300 pt-5 pb-2 px-3 rounded-t-sm text-sm"
            placeholder=" "
          />
          <label
            htmlFor="subject"
            className="absolute left-2 top-1 text-xs
              text-midnight transition-all duration-300 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base
               peer-placeholder-shown:text-gray-600 peer-focus:top-1 peer-focus:text-xs peer-focus:text-midnight"
          >
            Subject
          </label>
          {errors && errors.subject && (
            <p className="text-red-400 py-2">{errors.subject}</p>
          )}
        </div>
        <div className="relative py-5">
          <label htmlFor="message" className="text-base text-gray-600">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            onBlur={handleBlur}
            value={form.message}
            onChange={handleChange}
            rows="4"
            className="w-full border-b-2 border-gray-300 focus:outline-none
              focus:bg-gray-200 focus:border-midnight transition-all duration-300 pt-5 pb-2 px-3 rounded-t-sm text-sm"
            placeholder=" "
          />
          {errors && errors.message && (
            <p className="text-red-400 py-2">{errors.message}</p>
          )}
        </div>
        <div>
          <button
            type="submit"
            className="w-3/4 xs:w-2/4 py-2 bg-midnight text-white font-medium rounded-full hover:bg-blue-600 focus:outline-none flex justify-center space-x-2 items-center"
            disabled={status === "sending"}
          >
            <span>Send Message</span>
            <ArrowRightCircleIcon className="size-5 xs:size-8 text-black-500" />
          </button>
        </div>

        {/* Snackbar */}
        {status === "success" && (
          <div className="fixed left-1/2 bottom-8 -translate-x-1/2 bg-green-400 text-white px-6 py-3 rounded shadow-lg z-50 transition-all">
            Message sent successfully!
          </div>
        )}
        {status === "error" && (
          <div className="fixed left-1/2 bottom-8 -translate-x-1/2 bg-red-400 text-white px-6 py-3 rounded shadow-lg z-50 transition-all">
            Error sending message. Please try again later.
          </div>
        )}
      </form>
    </div>
  );
};

export default Form;
